var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diamond-hole",attrs:{"id":_vm.getId()}},[(!_vm.filledBy)?_c('img',{staticClass:"diamond-in-hole",attrs:{"src":_vm.getSource(),"alt":"diamond-in-hole","draggable":"false"}}):_vm._e(),(_vm.filledBy)?_c('v-diamond',{attrs:{"number":_vm.filledBy,"is-filled":true,"is-in-hole":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }